//components
import ListWidget from  '@/components/elements/widgets/ListWidget';
import PageWidget from  '@/components/elements/widgets/PageWidget';
import RSSWidget from  '@/components/elements/widgets/RSSWidget';
import ContactWidget from  '@/components/elements/widgets/ContactWidget';
import ImageWidget from  '@/components/elements/widgets/ImageWidget';
import VideoWidget from  '@/components/elements/widgets/VideoWidget';
import AudioWidget from  '@/components/elements/widgets/AudioWidget';
import FileWidget from  '@/components/elements/widgets/FileWidget';
import LegacyExistingWidget from  '@/components/elements/widgets/LegacyExistingWidget';
import WebPageWidget from  '@/components/elements/widgets/WebPageWidget';
import CombinedFeedWidget from  '@/components/elements/widgets/CombinedFeedWidget';
import DuplicateWidget from  '@/components/elements/widgets/DuplicateWidget';

//styling
import '../../../css/widgetPanel/widgetPanel.scss';


const WidgetPanelList = ({className, isCombinedFeedEnabled, isMainMenu}:{className?:string, isCombinedFeedEnabled: boolean, isMainMenu?: boolean }) => {

    if (isMainMenu) {
        return ( <section className={`widget-panel ${className || ''}`}>
                <div className="widget-row-1" style={{width:'100%'}}>
                    <ListWidget />
                    {isCombinedFeedEnabled && <CombinedFeedWidget />}
                    <PageWidget />
                    <ImageWidget />
                    <VideoWidget />
                    <AudioWidget />
                    <FileWidget />
                    <RSSWidget />
                    <ContactWidget />
                    <WebPageWidget />
                    <LegacyExistingWidget />
                    <DuplicateWidget />
                </div>
            </section>
        )
    }
    return (
        <section className={`widget-panel ${className || ''}`}>
           <div className="widget-row-1">
                <ListWidget />
                {isCombinedFeedEnabled && <CombinedFeedWidget />}
                <PageWidget />
                <ImageWidget />
                <VideoWidget />
                <AudioWidget />
           </div>

            <div className="widget-row-2">
                <FileWidget />
                <RSSWidget />
                <ContactWidget />
                <WebPageWidget />
                <LegacyExistingWidget />
                <DuplicateWidget />
            </div>
        </section>
    )
}
export default WidgetPanelList